import React, { FC } from 'react'
import classNamesBind from 'classnames/bind'
import Container from '@dashboard/components/Container'
import css from './styles.module.scss'

interface OwnProps {
  background?: string
  borderTop?: boolean
  containSides?: boolean
  lightGray?: boolean
  noMin?: boolean
  noPadding?: boolean
  noTopPadding?: boolean
  uncontained?: boolean
  uncontainedSmall?: boolean
  white?: boolean
  pullTop?: boolean
  children: React.ReactNode
}

const classNames = classNamesBind.bind(css)

const Body: FC<OwnProps> = ({
  background = '#f5f5f5',
  borderTop,
  containSides,
  lightGray,
  noMin,
  noPadding,
  noTopPadding,
  white,
  pullTop,
  children,
  uncontained,
  uncontainedSmall,
}: OwnProps) => {
  const classes = classNames('wrapper', {
    white,
    'no-padding': noPadding,
    'border-top': borderTop,
    'no-top-padding': noTopPadding,
    'light-gray': lightGray,
    'no-min': noMin,
    'contain-sides': containSides,
  })

  // Partials
  const renderChildren = () => {
    if (pullTop) return <div className={classNames('pullTop')}>{children}</div>

    if (uncontained) return children

    return <Container uncontainedSmall={uncontainedSmall}>{children}</Container>
  }

  return (
    <div className={classes} style={{ background }}>
      {renderChildren()}
    </div>
  )
}

export default Body
